export default "__VITE_ASSET__5c4ccf08__"